const supportConfig = {
  // Read an Announcement
  "/system/announcement.read": {
    protocol: "ws",
    resource: "/system/announcement",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support",
  },
  // Read News
  "/system/news.read": {
    protocol: "ws",
    resource: "/system/news",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "support",
  },
  // Update Read News
  "/system/news/:id/read.update": {
    protocol: "ws",
    resource: "/system/news/:id/read",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "support",
  },
};

export default supportConfig;
